<template>
  <div class="section-header">
    <div class="section-header-left">
      <MdiIcon
        v-if="icon"
        :name="icon"
        :size="20"
      />
      <span
        v-if="title"
        class="section-header-title"
      >{{ title }}</span>
      <el-tag
        v-if="count !== null && count !== undefined"
        size="small"
        effect="dark"
        class="section-header-count"
      >
        {{ count }}
      </el-tag>
    </div>
    <div class="section-header-right">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: '#02264A'
    },
    count: {
      type: [Number, String],
      default: null
    }
  }
};
</script>

<style scoped>
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px;
  /* Même fond que les onglets avec overlay de sélection */
  background-color: #02264A;
  background-image: linear-gradient(rgba(64, 158, 255, 0.25), rgba(64, 158, 255, 0.25));
  color: white;
  height: 48px;
  gap: 10px;
  margin-bottom: 0;
}

.section-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-header-title {
  font-size: 16px;
  font-weight: 500;
}

.section-header-count {
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
}

.section-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

@media (max-width: 992px) {
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 1em;
  }

  .section-header-right {
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .section-header-title {
    font-size: 14px;
  }

  .section-header-right :deep(.el-button) {
    font-size: 12px;
    padding: 6px 10px;
  }
}
</style>

<style>
/* ===== Dark mode styles pour SectionHeader ===== */
/* Garde le bleu foncé de la marque pour les headers de section */
html.dark .section-header {
  background-color: #02264a;
  background-image: linear-gradient(rgba(64, 158, 255, 0.2), rgba(64, 158, 255, 0.2));
}

html.dark .section-header-count {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
